import React, { useEffect, useState } from 'react';
import { CourseBox } from '../Home/CourseBox';
import Loading from '../_components/Loading';
import { courseService } from '../_services/course.service';

export const OngoingCourseList = ({ searchKey }) => {
  const [courseData, setCourseData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 8,
    },
    searchKey: '',
    myCourse: true,
  });

  useEffect(() => {
    query.searchKey = searchKey;
    setQuery(query);
    getAllOnGoingCourse(1, query);
  }, [searchKey]);

  const getAllOnGoingCourse = (pageNo, queryTemp) => {
    let queryNew = queryTemp ? queryTemp : query;
    queryNew.pageVo.pageNo = pageNo;
    setQuery(queryNew);
    if (pageNo == 1) {
      setIsLoading(true);
    }
    courseService.courseList(queryNew).then(
      (res) => {
        setIsLoading(false);
        if (res.data)
          if (res.data.rows.length == query.pageVo.noOfItems) {
            setShowViewMore(true);
          }
        if (res?.error_code == 0 && res?.data?.rows?.length) {
          if (pageNo == 1) {
            setCourseData(res?.data?.rows);
          } else {
            setCourseData((prev) => [...prev, ...(res?.data?.rows ?? [])]);
          }
        } else {
          setCourseData([]);
        }
      },
      (err) => {
        console.log(err);
        setCourseData([]);
        setIsLoading(false);
      },
    );
  };
  return (
    <div className='ongoingcourselist mt-5'>
      <div className='listhead'>Ongoing Courses</div>
      <div className=' d-flex flex-wrap gap-4 listcontainer'>
        {courseData?.map((course, index) => {
          return <CourseBox courseData={course} key={index} />;
        })}
      </div>
      {showViewMore && <div className='viewmorebtn'>View More</div>}

      {!isLoading && courseData.length == 0 && (
        <div className='nodatatitle'> No Courses found </div>
      )}
      {isLoading && <Loading />}
    </div>
  );
};
